import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { a11ySelection } from '../../lib/a11yUtils';
import s from './optionsList.module.css';

export const mapStateToProps = ({ options: { selectedOptions } }) => ({
  selectedOptions,
});

export const Component = ({
  selectedOptions,
  listTitle,
  listDescription,
  listOptions,
  listType,
  listOnChange,
}) => (
  <div className={`${s.options_list_container} options-list-container`}>
    <h2 className={s.options_list_title} aria-level="3">
      {listTitle}
    </h2>
    {listDescription && <div dangerouslySetInnerHTML={{ __html: listDescription }} />}
    <div className={s.options_list_holder}>
      {listOptions.map((option, index) => {
        const selectedValue = selectedOptions[option.key]
          ? selectedOptions[option.key].value
          : undefined;
        return (
          // eslint-disable-next-line react/no-array-index-key
          <div key={`${option.key}-${index}`}>
            {listType === 'radio' && (
              <input
                type="radio"
                value={option.value}
                checked={selectedValue === option.value}
                onChange={() => listOnChange(option, option.value)}
                id={`${option.key}-${listType}-${index}`}
                className={`option_input ${s.option_input} ${s.option_radio}`}
                data-test={`options-list-item-${index}`}
              />
            )}
            {listType === 'booleanRadio' && (
              <input
                type="radio"
                checked={selectedValue === option.value}
                onChange={() => listOnChange(option, option.value)}
                id={`${option.key}-${listType}-${index}`}
                className={`option_input ${s.option_input} ${s.option_radio}`}
                data-test={`options-list-item-${index}`}
              />
            )}
            {listType === 'checkbox' && (
              <input
                type="checkbox"
                checked={Boolean(selectedValue)}
                onChange={() => listOnChange(option, selectedValue ? false : option.value)}
                id={`${option.key}-${listType}-${index}`}
                className={`option_input option_checkbox ${s.option_input} ${s.option_checkbox}`}
                data-test={`options-list-item-${index}`}
              />
            )}
            {/* eslint-disable jsx-a11y/role-has-required-aria-props */
            /* eslint-disable jsx-a11y/label-has-for */}
            <label
              htmlFor={`${option.key}-${listType}-${index}`}
              className={`option_label ${s.option_label}`}
              dangerouslySetInnerHTML={{ __html: option.text }}
              data-test={`options-list-label-${index}`}
              onKeyDown={a11ySelection((e) => e.target.click())}
              role="radio"
            />
          </div>
        );
      })}
    </div>
  </div>
);

Component.propTypes = {
  selectedOptions: PropTypes.object.isRequired,
  listTitle: PropTypes.string.isRequired,
  listDescription: PropTypes.string.isRequired,
  listOptions: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]).isRequired,
      text: PropTypes.string.isRequired,
    }),
  ).isRequired,
  listType: PropTypes.oneOf(['radio', 'booleanRadio', 'checkbox']).isRequired,
  listOnChange: PropTypes.func.isRequired,
};

export const OptionsList = connect(mapStateToProps)(Component);
